module.exports = __webpack_public_path__ + "static/media/in_a_week_sample_1.326ed2db.jpg";